import { InjectionToken } from '@angular/core';
import { CookieStore } from './cookie-store';

export const COOKIE_SERVICE = new InjectionToken<CookieStore>('CookieStore');
